// import styles from "./FromComponent.module.css";
// import { useAuth } from "../../context/Auth";
// import { NavbarSearchIcon } from "../../icons/Icon";
// const SearchBar = ({
//   onChange,
//   value,
//   placeholder,
//   type,
//   maxLength,
//   padding,
//   borderRadius,
//   style,
//   fontSize,
//   // fontWeight,
//   onFocus,
//   onBlur,
// }) => {
//   const { mode } = useAuth();

//   return (
//     <div
//       className={style ? style : styles.navbar_Search_Bar}
//       style={{
//         padding: padding ? padding : "10px 20px",
//         backgroundColor: mode && "#1b1d21",
//         borderColor: mode && "#1b1d21",
//         borderRadius: borderRadius,
//       }}
//     >
//       <NavbarSearchIcon color={mode ? "#ffffff" : "#646B88"} />
//       <input
//         type={type ? type : "text"}
//         placeholder={placeholder}
//         className={
//           mode ? styles.search_Bar_Input_Dark : styles.search_Bar_Input
//         }
//         onChange={onChange}
//         value={value}
//         // maxLength={Number(maxLength)}
//         maxLength={maxLength}
//         style={{
//           fontSize: fontSize && fontSize,
//           "--placeholder-font-weight": "300",
//         }}
//         autoComplete={"new-password"}
//         onFocus={onFocus && onFocus}
//         onBlur={onBlur && onBlur}

//       />
//     </div>
//   );
// };

// export default SearchBar;


import styles from "./FromComponent.module.css";
import { useAuth } from "../../context/Auth";
import { NavbarSearchIcon } from "../../icons/Icon";

const SearchBar = ({
  onChange,
  onClear,
  value,
  placeholder,
  type,
  maxLength,
  padding,
  borderRadius,
  style,
  fontSize,
  onFocus,
  onBlur,
}) => {
  const { mode } = useAuth();

  return (
    <div
      className={style ? style : styles.navbar_Search_Bar}
      style={{
        padding: padding ? padding : "10px 20px",
        backgroundColor: mode && "#1b1d21",
        borderColor: mode && "#1b1d21",
        borderRadius: borderRadius,
      }}
    >
      <NavbarSearchIcon color={mode ? "#ffffff" : "#646B88"} />

      <input
        type={type || "text"}
        placeholder={placeholder}
        className={
          mode ? styles.search_Bar_Input_Dark : styles.search_Bar_Input
        }
        onChange={onChange}
        value={value}
        maxLength={maxLength}
        style={{
          fontSize,
          "--placeholder-font-weight": "300",
        }}
        autoComplete="new-password"
        onFocus={onFocus}
        onBlur={onBlur}
      />

      {value && (
        <span
          onClick={onClear}
          style={{
            color: "red",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "bold",
            // marginLeft: "8px",
            userSelect: "none",
          }}
        >
          ✕
        </span>
      )}
    </div>
  );
};

export default SearchBar;